import React from 'react';

export default function RootLayout({ children }) {
    return (
        <>
            {children}
        </>
    );
}
